export function createImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', (error) => reject(error))
    image.setAttribute('crossOrigin', 'anonymous')
    image.src = url
  })
}

function clamp(n, min, max) {
  return Math.min(max, Math.max(min, n))
}

/**
 * Crops the image based on pixel crop area and exports to a fixed square PNG.
 * @param {string} imageSrc objectURL or data URL
 * @param {{x:number,y:number,width:number,height:number}} pixelCrop pixels from react-easy-crop
 * @param {{size:number}} options fixed output size in px (square)
 * @returns {Promise<{blob: Blob, objectUrl: string}>}
 */
export async function getCroppedSquarePng(imageSrc, pixelCrop, { size = 256 } = {}) {
  const image = await createImage(imageSrc)
  const canvas = document.createElement('canvas')
  canvas.width = size
  canvas.height = size

  const ctx = canvas.getContext('2d')
  if (!ctx) throw new Error('Canvas not supported')

  // Fill transparent background; keep as-is for PNG transparency.
  ctx.clearRect(0, 0, size, size)

  const sx = clamp(pixelCrop.x, 0, image.width)
  const sy = clamp(pixelCrop.y, 0, image.height)
  const sw = clamp(pixelCrop.width, 1, image.width - sx)
  const sh = clamp(pixelCrop.height, 1, image.height - sy)

  ctx.imageSmoothingEnabled = true
  ctx.imageSmoothingQuality = 'high'

  ctx.drawImage(image, sx, sy, sw, sh, 0, 0, size, size)

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'))
  if (!blob) throw new Error('Failed to export PNG')
  const objectUrl = URL.createObjectURL(blob)
  return { blob, objectUrl }
}

